/** Keep legacy policy pages until their text has been compared with the admin.
 * See docs/POLICY_ROLLOUT.md before enabling Policy Pages.
 */
export const policyPagesEnabled: boolean = false;
